import axios from './axios';
const baseUrl = 'http://localhost:8000/api/';
export default {
    get(url) {
        return axios.get(url);
    },
    newpost(url, payload = {}) {
        return new Promise((resolve, reject) => {
            fetch(`${baseUrl}${url}`, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, cors, *same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow", // manual, *follow, error
                referrer: "no-referrer", // no-referrer, *client
                body: JSON.stringify(payload), // body data type must match "Content-Type" header
            }).then(resp => resolve(resp.json()))
            .catch(reject);
        })
    },
    post(url, payload = {}) {
        const formData = new FormData();
        Object.keys(payload).map(key => formData.append(key, payload[key]));
        return new Promise((resolve, reject) => {
            axios.post(url, formData)
                .then(resp => {
                    resolve(resp);
                })
                .catch(error => {
                    reject(error);
                });
        });
        // return axios.post(url, payload);
    },
    delete(url) {
        return axios.delete(url);
    },
    put(url, payload) {
        return axios.put(url, payload);
    },
    querify(params) {
        if (!params || !Object.keys(params).length) return '';

        const arrParams = [];
        Object.keys(params).map(key => typeof params[key] !== 'undefined' && arrParams.push(`${key}=${params[key]}`));
        const join = !!arrParams.length? '?': '';
        const queryString = join + arrParams.join('&');
        return queryString;
    }
};



// WEBPACK FOOTER //
// ./src/repositories/base.repository.js